import { EventsEmitter } from "../../../shared/event-emitter/EventEmitter";
import { NotificationTemplateComponent } from "../../../shared/notification-template/notification-template.component";
import { BaseUnsubscribeComponent } from "../base-unsubscribe/base-unsubscribe.component";

export abstract class AutoNotifyBaseComponent extends BaseUnsubscribeComponent {
  constructor(protected readonly eventEmitter: EventsEmitter) {
    super();
  }

  

  viewMode = "Submit";
  public messageTemplate: any;
  public recipients: any[] = [];
  public allChecked: boolean = true;
  private notificationTemplateRef: NotificationTemplateComponent;

  abstract onSubmit(): void;
  abstract onCancel(): void;

  protected setNotificationTemplateRef(ref: NotificationTemplateComponent) {
    this.notificationTemplateRef = ref;
  }

  public get recipientsCount(): number {
    let count = this.notificationTemplateRef ? this.notificationTemplateRef?.getCountForRecipients() : 0;
    return count;
  }


  getSelectedRecipients() {
    return this.notificationTemplateRef
      ? this.notificationTemplateRef.getSelectedRecipients()
      : [];
  }

  changeViewModeToNotification() {
    this.viewMode = "NotificationDetail";
  }
  changeViewModeToSubmit() {
    this.viewMode = "Submit";
  }
}
